module.exports = __webpack_public_path__ + "img/aarie_beleaka_no.23a04007.png";